import { ClosureSubType, HAZARD_MARKERS, Scheme, UiListTileLeadingColor } from '@/features/hazards';

type ClosuresToSchemeMap = Record<ClosureSubType, Scheme>;

export const closuresToSchemeMap: ClosuresToSchemeMap = {
  [ClosureSubType.SchoolClosureEntity]: {
    leadingColor: UiListTileLeadingColor.Black,
    icon: HAZARD_MARKERS['ew-school-closure'],
  },
  [ClosureSubType.RoadClosureEntity]: {
    leadingColor: UiListTileLeadingColor.Black,
    icon: HAZARD_MARKERS['ew-road-closure'],
  },
  [ClosureSubType.FacilityOrParkClosureEntity]: {
    leadingColor: UiListTileLeadingColor.Black,
    icon: HAZARD_MARKERS['ew-facility-or-park-closure'],
  },
  [ClosureSubType.ParkClosureEntity]: {
    leadingColor: UiListTileLeadingColor.Black,
    icon: HAZARD_MARKERS['ew-park-closure'],
  },
  [ClosureSubType.GenericClosureEntity]: {
    leadingColor: UiListTileLeadingColor.Black,
    icon: HAZARD_MARKERS['ew-other-closure'],
  },
};
